//@ts-check

import React, { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { PUBLIC_PATH } from '../../constants/index';
import {
    addComment, addNewEntriesByDataModel, changeAssigneeRequest, clearReduxDataOfCurrentComponent,
    clearSuccessMsg, completeReviewAction, downloadContractPDFAction, downloadSheet, duplicatesGetRequest, duplicatesMoveRequest, executeWorkFlow, executeWorkFlowReject, finalDocument, getAllOtherDocs, getAuditTrailsData, getChargeCodes, getContractDataById, getDataModelById, getDataModels, getEventByID, getGroups,
    getGroupsByMemberId, getMembersList, getModelData, getModelDataDropDown, getNextRespondent, getNextTasks, getPDFForOtherDoc, getSupportingDocuments, getVISData, getWorkflow, hideSuccessMessage,
    initiateAction, lockDocument, otherDocMove, splitPDF, unlockDocument, updateContractAnnotations, updateDataModelData, uploadSupportDocument, rejectReviewAction, getDuplicateDocById,
    reInitiateWorkflow, getOthersAuditTrailsData
} from '../../store/actions';
import { Loader } from "../loader";
import DuplicateViewerWrapper from './DuplicateViewerWrapper';

const DuplicateViewer = (props) => {
    // To avoid unwanted popups on list pages (when redirecting to list page from view page)
    useEffect(() => {
        return () => {
            props.clearReduxDataOfCurrentComponent({
                key: "message",
                subKey: []
            })
        }
    }, [])

    return <DuplicateViewerWrapper {...props} loader={<Loader />} publicPath={PUBLIC_PATH} />
}

const mapDispatchToProps = {
    downloadContractPDFAction,
    clearReduxDataOfCurrentComponent,
    getContractDataById,
    getDataModels,
    getAllOtherDocs,
    getPDFForOtherDoc,
    otherDocMove,
    hideSuccessMessage,
    updateDataModelData,
    clearSuccessMsg,
    downloadSheet,
    getModelDataDropDown,
    getEventByID,
    initiateAction,
    getMembersList,
    updateContractAnnotations,
    getDataModelById,
    getModelData,
    getAuditTrailsData,
    changeAssigneeRequest,
    completeReviewAction,
    getWorkflow,
    getNextTasks,
    reInitiateWorkflow,
    executeWorkFlow,
    getNextRespondent,
    getChargeCodes,
    executeWorkFlowReject,
    addComment,
    addNewEntriesByDataModel,
    getGroups,
    getGroupsByMemberId,
    getSupportingDocuments,
    finalDocument,
    splitPDF,
    uploadSupportDocument,
    getVISData,
    lockDocument,
    unlockDocument,
    duplicatesGetRequest,
    duplicatesMoveRequest,
    rejectReviewAction,
    getDuplicateDocById,
    getOthersAuditTrailsData
};

const mapStateToProps = state => {
    return {
        formData: state.form,
        dataModels: state.dataModels,
        user: state.user,
        db: state.db,
        action: state.action,
        appConfig: state.appConfig.app,
        PUBLIC_PATH: PUBLIC_PATH,
        members: state.appConfig.members,
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DuplicateViewer));